import React from 'react';
import { Pagination } from "react-bootstrap";

const Paginations = ({ total, currentPage, perPage, onPageChange }) => {
    const totalPages = Math.ceil(total / perPage);

    const getPaginationItems = () => {
        const pages = [];
        const delta = 1;
        const range = [];

        for(let i = 1; i <= totalPages; i++) {
            if(i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
                range.push(i);
            }
        }

        let lastPage = 0;
        for(let i of range) {
            if(lastPage && i - lastPage > 1) {
                pages.push("ellipsis");
            }
            pages.push(i);
            lastPage = i;
        }

        return pages;
    };

    const handlePageChange = (page) => {
        if(typeof page === "number" && page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    return (
        <Pagination>
            <Pagination.Prev 
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1} 
            />

            {getPaginationItems().map((item, index) => 
                item === "ellipsis" ? (
                    <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                ) : (
                    <Pagination.Item
                        key={`page-${item}`}
                        active={item === currentPage}
                        onClick={() => handlePageChange(item)}
                    >
                        {item}
                    </Pagination.Item>
                )
            )}

            <Pagination.Next 
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === totalPages} 
            />
        </Pagination>
    )
};

export default Paginations;
